export enum CardType {
  Sky = 'Sky',
  Orchid = 'Orchid',
  Blush = 'Blush',
  Sand = 'Sand',
}
